export default ($parse) => ({
    require: 'ngModel',
    link(scope, element, attrs, modelCtrl) {
        const capitalize = function (inputValue) {
            if (inputValue == undefined) inputValue = '';
            var capitalized = inputValue.toUpperCase();
            if (capitalized !== inputValue) {
                modelCtrl.$setViewValue(capitalized);
                modelCtrl.$render();
            }
            return capitalized;
        }

        if (attrs.capitalize !== 'off') {
            modelCtrl.$parsers.push(capitalize);
            capitalize(scope[attrs.ngModel]); // capitalize initial value
        }
    }
});